class BCService {
  private async fetchWithAuth(url: string, options: RequestInit = {}) {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Aucun token d\'authentification trouvé');
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
      ...options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    return response.json();
  }

  async lancerConsultationRang(operationId: string, rang: number, data: any): Promise<void> {
    const payload = {
      operation_id: operationId,
      rang: rang,
      ...data
    };

    await this.fetchWithAuth(`/operation-ms/${operationId}/consultation/rang/${rang}`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async accepterCommande(operationId: string): Promise<void> {
    await this.fetchWithAuth(`bdc/commande/${operationId}/accept`, {
      method: 'POST'
    });
  }

  async refuserCommande(operationId: string, rang: number, reason?: string): Promise<void> {
    const payload = {
      operation_id: operationId,
      rang: rang,
      accepted: false,
      reason: reason || ''
    };

    await this.fetchWithAuth(`/operation-ms/${operationId}/rang/${rang}/response`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
}

export const bcService = new BCService();